import { client } from '../http';

export default {
  async fetchInvalidCredentialsState() {
    const response = await client.get('/api/invalid-credentials-state');
    return response.data;
  },
};
